import React from 'react';
import { Menu } from '@milanote/roma';
import { GridListHeader, GridListSection as AriaGridListSection, Key } from 'react-aria-components';

import LabelListItem from './LabelListItem';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { cx } from '@milanote/roma/utils/cx';

type Props = {
    checkedLabelIds: Set<Key>;
    editingLabelId: string | null;
    header?: string;
    handleClickEdit?: (label: Label) => void;
    isSheet?: boolean;
    labels: Label[];
    onEditingChange: (labelId: string, nextIsEditing: boolean) => void;
    sectionClassName?: string;
    sectionId?: string;
    showSeparator?: boolean;
    size?: 'sm' | 'lg';
};

const styles = {
    sizes: {
        sm: {
            separator: '-mx-1.5',
        },
        lg: {
            separator: '-mx-3.5',
        },
    },
};

const LabelListSection: React.FC<Props> = ({
    checkedLabelIds,
    editingLabelId,
    header,
    handleClickEdit,
    isSheet = false,
    labels,
    onEditingChange,
    sectionClassName,
    sectionId,
    showSeparator = false,
    size = 'sm',
}) => {
    if (!labels.length) return null;

    const sizeStyles = styles.sizes[size];

    const content = (
        <>
            {(header || showSeparator) && (
                <GridListHeader>
                    {showSeparator && <Menu.Base.Separator className={cx(sizeStyles.separator, !header && 'pb-0.5')} />}
                    {header && <Menu.Base.Header className="px-4">{header}</Menu.Base.Header>}
                </GridListHeader>
            )}
            {labels.map((label) => (
                <LabelListItem
                    key={label._id}
                    label={label}
                    onEditingChange={onEditingChange}
                    onEditClick={handleClickEdit}
                    isSheet={isSheet}
                    isSelected={checkedLabelIds.has(label._id)}
                    isEditing={editingLabelId === label._id}
                    size={size}
                />
            ))}
        </>
    );

    if (!sectionId) return content;

    return (
        <AriaGridListSection id={sectionId} className={sectionClassName}>
            {content}
        </AriaGridListSection>
    );
};

export default LabelListSection;
